import type { BonusInfoConfig } from '../../bonusInfo.types.ts';

const BONUS_INFO: BonusInfoConfig = {
  showMaxLimits: true,
};

export { BONUS_INFO };
